import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LINK_FILTER, } from '@as-react/common-types';
import { useState } from 'react';
import { Box, Button, ButtonVariant, Input, InputType, AutoComplete, ButtonType, IconName, IconSize, Icon, ConditionalWrapper, ScrollableList, Group, GroupGutter, ScrollableListVariant, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FilterLink } from './FilterLink';
import { FilterSizes } from './FilterSizes';
const DEFAULT_COLLAPSED_ITEMS_COUNT = 8;
const MAX_VIEW_MORE_ITEMS = 20;
const SCROLLABLE_LIST_HEIGHT = '276px';
export const FilterSelectList = ({ desktop, filter, onFilterItemChange, type, toggleFilterOptions = true, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [showAll, setShowAll] = useState(false);
    const [search, setSearch] = useState('');
    const toggleFilterValue = (e, filterValueObject) => {
        if (type === LINK_FILTER) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
        }
        onFilterItemChange({
            filterOn: filter.filterOn,
            filterOnName: filter.name,
            filteredItems: [
                {
                    filterKey: filterValueObject.filterKey,
                    filterKeyName: filterValueObject.name,
                    filterOn: filter.filterOn,
                    filterOnName: filter.name,
                    filterType: type,
                },
            ],
            filterType: type,
            filterDisplayHint: filter.displayHint,
            filterContentType: filter.filterContentType,
            queryParamKey: filter.queryParamKey,
        });
    };
    const handleSearchChange = (e) => setSearch(e.target.value);
    const handleSearchReset = () => setSearch('');
    const filtersSize = filter.values.length;
    const itemsToShow = filter.itemsToShow
        ? filter.itemsToShow
        : filtersSize <= MAX_VIEW_MORE_ITEMS
            ? DEFAULT_COLLAPSED_ITEMS_COUNT
            : Infinity;
    const hasTooManyItems = filtersSize > itemsToShow && filtersSize <= MAX_VIEW_MORE_ITEMS;
    const isSearchEnabled = filter.filterOn === 'brand' &&
        filter.visibleSearchBox === 'yes' &&
        ((desktop && filtersSize > (filter.itemsToShow ? filter.itemsToShow : DEFAULT_COLLAPSED_ITEMS_COUNT)) || !desktop);
    const searchFieldId = `${filter.name}_search`;
    const items = (() => {
        if (search) {
            const searchTerm = search.toLowerCase();
            if (searchTerm.length === 1) {
                return filter.values.filter(({ name }) => name.toLowerCase().startsWith(searchTerm));
            }
            else {
                return filter.values.filter(({ name }) => name.toLowerCase().includes(searchTerm));
            }
        }
        return !toggleFilterOptions || showAll ? filter.values : filter.values.slice(0, itemsToShow);
    })();
    return (_jsxs(_Fragment, { children: [!desktop && type === LINK_FILTER ? (_jsx(FilterLink, { items: items, toggleFilterValue: toggleFilterValue })) : (_jsx(ConditionalWrapper, { condition: !desktop && isSearchEnabled, wrapper: children => (_jsx(Box, { fullHeight: true, mobile: { bleed: { marginInline: 2 } }, children: _jsx(Group, { column: true, fullHeight: true, gutter: GroupGutter.NONE, children: children }) })), children: _jsxs(_Fragment, { children: [isSearchEnabled && (_jsx(Box, { mobile: {
                                spacing: {
                                    marginBottom: 2,
                                    marginLeft: desktop ? 0 : 2,
                                    marginRight: desktop ? 0 : 2,
                                },
                            }, children: _jsx(Input, { id: searchFieldId, name: searchFieldId, value: search, onChange: handleSearchChange, type: InputType.SEARCH, placeholder: t('product.lister.filter.brand.search'), autoComplete: AutoComplete.OFF, adornmentEnd: search ? (_jsx(Button, { dataQA: `${searchFieldId}_reset`, onClick: handleSearchReset, type: ButtonType.RESET, variant: ButtonVariant.TRANSPARENT, icon: { name: IconName.CLOSE, size: IconSize.MAJOR } })) : (_jsx(Icon, { name: IconName.MAGNIFY, size: IconSize.MAJOR })) }) })), Boolean(items.length) && (_jsx(ConditionalWrapper, { condition: !desktop && isSearchEnabled, wrapper: children => (_jsx(ScrollableList, { children: _jsx(Box, { mobile: { spacing: { paddingLeft: 2, paddingRight: 2 } }, children: children }) })), children: _jsx(ConditionalWrapper, { condition: Boolean(desktop) && items.length > MAX_VIEW_MORE_ITEMS, wrapper: children => (_jsx(Box, { mobile: { spacing: { paddingBottom: 1 } }, children: _jsx(ScrollableList, { variant: ScrollableListVariant.SHADOW_LIGHT, height: SCROLLABLE_LIST_HEIGHT, children: children }) })), children: _jsx(FilterSizes, { items: items, type: type, filter: filter, toggleFilterValue: toggleFilterValue, desktop: desktop, search: search }) }) }))] }) })), toggleFilterOptions && hasTooManyItems && !search && (_jsx(Box, { mobile: { spacing: { paddingBottom: 2, paddingTop: 1 } }, children: _jsx(Button, { variant: ButtonVariant.LINK, onClick: () => setShowAll(!showAll), text: showAll ? t('product.lister.show.less') : t('product.lister.show.more') }) }))] }));
};
